var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCinema(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 26 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9739 3.98535C19.315 3.80072 19.7293 4.02494 19.7293 4.3942L19.7293 10.5517C19.7293 10.9301 19.2964 11.1757 18.9551 10.991L13.2671 7.91229C12.9258 7.72759 12.9364 7.25328 13.2859 7.06409L18.9739 3.98535Z",
    fill: "#FBFBFB",
    stroke: "#756D6D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.633301,
    width: 14.7118,
    height: 13.7298,
    rx: 2.5,
    fill: "#FBFBFB",
    stroke: "#756D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinema);
export default __webpack_public_path__ + "static/media/Cinema.a64de45967eaf2f8e438c32662e07bb1.svg";
export { ForwardRef as ReactComponent };